import { AppWrapperProps } from './AppWrapper.types'
import AppWrapperStyled from './AppWrapper.styles'

const AppWrapper = ({ children, styles }: AppWrapperProps) => (
  <AppWrapperStyled
    className="AppWrapper"
    data-testid="app-wrapper"
    sx={styles}>
    {children}
  </AppWrapperStyled>
)

export default AppWrapper
